import { render } from "./linkFollower.vue?vue&type=template&id=10a6516c&scoped=true"
import script from "./linkFollower.vue?vue&type=script&lang=js"
export * from "./linkFollower.vue?vue&type=script&lang=js"

import "./linkFollower.vue?vue&type=style&index=0&id=10a6516c&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a6516c"]])

export default __exports__